// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-publicacion-revista-js": () => import("./../../../src/templates/PublicacionRevista.js" /* webpackChunkName: "component---src-templates-publicacion-revista-js" */),
  "component---src-templates-revista-js": () => import("./../../../src/templates/Revista.js" /* webpackChunkName: "component---src-templates-revista-js" */)
}

